<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span class="text">{{ getValue() }}</span>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['component', 'components', 'value'],
  name: 'DatepickerReadOnly',
  methods: {
    getValue: function () {
      let dateString
      if (!(moment(this.value, 'DD/MM/YYYY', true).isValid())) {
        dateString = moment(this.value).format('DD/MM/YYYY')
        return dateString
      }
      dateString = this.value
      if (dateString.toLowerCase() === 'invalid date') {
        return '-'
      }
      return dateString
    }
  }
}
</script>
